import Order from "./containers/Order";

export default Order;
